import React, { useEffect, useState } from "react";
import styles from "./range-slider.module.scss";

interface RangeSliderProps {
  label: string;
  min: number;
  max: number;
  step?: number;
  defaultValue: number;
  unit?: string;
  onChange: (value: number) => void;
}

const RangeSlider: React.FC<RangeSliderProps> = ({
  label,
  min,
  max,
  step = 1,
  defaultValue,
  unit,
  onChange,
}) => {
  const [value, setValue] = useState<number>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(e.target.value);
    setValue(newValue);
    onChange?.(newValue);
  };

  useEffect(() => {
    setValue(defaultValue ?? min);
  }, [defaultValue, min]);

  return (
    <div className={styles.sliderContainer}>
      <label className={`${styles.sliderLabel} text-label`}>
        {label}
        <span className={`${styles.value} text-label`}>
          {value}&nbsp;{unit}
        </span>
      </label>
      <input
        type="range"
        className={styles.range}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleChange}
      />
    </div>
  );
};

export default RangeSlider;
